import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import OrdersList from '../views/OrdersList.vue';
import ReturnsList from '../views/ReturnsList.vue';
import CommentsAndRates from '../views/CommentsAndRates.vue';
import Heartbeat from '../views/Heartbeat.vue';
import CronTasksList from '../views/CronTasksList.vue';
import ManualTasksList from '../views/ManualTasksList.vue';
import Logs from '../views/Logs.vue';
import Dashboard from '../views/Dashboard.vue';
import CreateAllegroIntegration from '../views/CreateAllegroIntegration.vue';
import IntegrationList from '../views/IntegrationList.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/heartbeat',
    name: 'heartbeat',
    component: Heartbeat,
  },
  {
    path: '/logs',
    name: 'logs',
    component: Logs,
  },
  {
    path: '/integration/allegro/create',
    name: 'integration/allegro/create',
    component: CreateAllegroIntegration,
  },
  {
    path: '/integration/list',
    name: 'integration/list',
    component: IntegrationList,
  },
  {
    path: '/orders/list',
    name: 'orders/list',
    component: OrdersList,
  },
  {
    path: '/returns/list',
    name: 'returns/list',
    component: ReturnsList,
  },
  {
    path: '/tasks/cron/list',
    name: 'tasks/cron/list',
    component: CronTasksList,
  },
  {
    path: '/tasks/manual/list',
    name: 'tasks/manual/list',
    component: ManualTasksList,
  },
  {
    path: '/comments-and-rates',
    name: 'comments-and-rates',
    component: CommentsAndRates,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
